import StepTwo from "@/components/dashboard/moneyExchange/StepTwo";

export default function MoneyExchangeStepTwo() {
  return <StepTwo />;
}
